module.exports = __webpack_public_path__ + "static/media/proj4.markdown.5c0f388b.md";